import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleAddModal, toggleNeedRefresh } from '../../store/faqTabSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';

import './Faq.css';

function AddNewFaq() {
  const dispatch = useDispatch();

  const isModalOpen = useSelector((state) => state.faq.addModalOpen);

  const [formData, setFormData] = useState({
    id: '',
    questionPl: '',
    answerPl: '',
    questionEng: '',
    answerEng: '',
  });


  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);


  useEffect(() => {
    const isValid = formData.questionPl.trim() !== '' &&
                    formData.answerPl.trim() !== '' &&
                    formData.questionEng.trim() !== '' &&
                    formData.answerEng.trim() !== '';
    setIsSubmitDisabled(!isValid);
  }, [formData]); // Monitoruj zmiany w `formData`

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();      
    try {
      const data = {
        question: formData.questionPl,
        answer: formData.answerPl,
        questionEng: formData.questionEng,
        answerEng: formData.answerEng,
      };

      const response = await ApiService.addNewFaq(data);
      console.log('Nowa notyfikacja została dodana:', response);

      dispatch(toggleAddModal());
      dispatch(toggleNeedRefresh());
    } catch (error) {
      console.error('Błąd podczas dodawania nowej notyfikacji:', error);
    }
  };

  const handleCloseModal = () => {
    dispatch(toggleAddModal());
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
      <h2>Dodaj pozycję FAQ</h2>
      <form onSubmit={handleSubmit}>
        <div></div>
        <div>
          <label htmlFor="questionPl">Pytanie w języku polskim</label>
          <input
            type="text"
            id="questionPl"
            name="questionPl"
            value={formData.questionPl}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="answerPl">Odpowiedź w języku polskim</label>
          <input
            type="text"
            id="answerPl"
            name="answerPl"
            value={formData.answerPl}
            onChange={handleInputChange}
            required
          />
        </div>
          <div>
              <label htmlFor="questionEng">Pytanie w języku angielskim</label>
              <input
                  type="text"
                  id="questionEng"
                  name="questionEng"
                  value={formData.questionEng}
                  onChange={handleInputChange}
                  required
              />
          </div>
          <div>
              <label htmlFor="answerEng">Odpowiedź w języku angielskim</label>
              <input
                  type="text"
                  id="answerEng"
                  name="answerEng"
                  value={formData.answerEng}
                  onChange={handleInputChange}
                  required
              />
          </div>
        <div className="modal-margin-top-20">
          <button className="buttons-modal-appearance2-almost-white" type="button" onClick={handleCloseModal}>
            Anuluj
          </button>
          <button type="submit" disabled={isSubmitDisabled}>
            Dodaj
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default AddNewFaq;
